import { makeAutoObservable } from 'mobx';
import { IAttendee } from '../../../api/dao/attendee-dao';
import { AttendeeSortFields, AttendeeStatus } from '../../../constans/attendee-enums';
import { SortDirection } from '../../../constans/common-constants';
import { ActivityAttendeeCountService } from '../activity-attendee-count-service/activity-attendee-count-service';
import { getActivityAttendeeCountService } from '../activity-attendee-count-service/activity-attendee-count-service-instance';
import { AttendeeEntity } from '../attendee-entity/attendee-entity';

type TAttendeeFilters = {
  [key in string]: AttendeeStatus[]
}

interface IAttendeesService {

  attendee: AttendeeEntity[];

  activityFilters: AttendeeStatus[];

  sortDirectionValue: SortDirection;

  switchSortDirection: () => void;

  initAttendees(attendees: IAttendee[], totalCount: number): void;

  getActivityAttendeeCountService(): ActivityAttendeeCountService;

  selectActivityFilter(filterStatus: AttendeeStatus): void;
}

class AttendeesService implements IAttendeesService {
  private sortDirection: SortDirection;
  private attendeeEntities: AttendeeEntity[];
  private activityFilterStatuses: TAttendeeFilters;
  private activeSortField: string;
  private searchQuery = '';
  private isSearhProcess = false;

  constructor (
    private readonly activityAttendeeCountService: ActivityAttendeeCountService = getActivityAttendeeCountService()
  ) {
    this.init();
  }

  get isSearch (): boolean {
    return this.isSearhProcess;
  }

  get sortDirectionValue (): SortDirection {
    return this.sortDirection;
  }

  get attendee (): AttendeeEntity[] {
    return this.attendeeEntities;
  }

  get activityFilters (): AttendeeStatus[] {
    const filters: AttendeeStatus[] = Object.values(this.activityFilterStatuses).reduce((acc, value) => acc.concat(...value), []);
    return filters;
  }

  get searchQueryString (): string {
    return this.searchQuery.trim();
  }

  get inputSearchValue (): string {
    return this.searchQuery;
  }

  get activeSortFieldParam (): string {
    return this.activeSortField;
  }

  public getActivityAttendeeCountService = (): ActivityAttendeeCountService => {
    return this.activityAttendeeCountService;
  };

  public onSearch = (searchQuery: string): void => {
    this.searchQuery = searchQuery;

    this.toggleIsSearch();
  };

  public selectActivityFilter = (filterStatus: AttendeeStatus | AttendeeStatus[]): void => {
    const prepareFilterStructure = Array.isArray(filterStatus) ? filterStatus : [filterStatus];
    const filterName = prepareFilterStructure[0];

    if (this.activityFilterStatuses[filterName]) {
      delete this.activityFilterStatuses[filterName];
      return;
    }

    this.activityFilterStatuses[filterName] = prepareFilterStructure;
  };

  public initAttendees = (attendees: IAttendee[]): void => {
    if (!attendees?.length) {
      this.attendeeEntities = [];
      return;
    }

    this.attendeeEntities = attendees.map((attendee: IAttendee) => new AttendeeEntity(attendee));
  };

  public setActiveSortField = (value: AttendeeSortFields): void => {
    this.activeSortField = value;
  };

  public setSortDirection = (value: SortDirection): void => {
    this.sortDirection = value;
  };

  public switchSortDirection = (): void => {
    this.sortDirection = this.sortDirection === SortDirection.ASC
      ? SortDirection.DESC
      : SortDirection.ASC;
  };

  private init = (): void => {
    makeAutoObservable(this);
    this.activityFilterStatuses = {
      [AttendeeStatus.ACTIVE]: [AttendeeStatus.ACTIVE]
    };
    this.attendeeEntities = [];
    this.sortDirection = SortDirection.ASC;
    this.activeSortField = AttendeeSortFields.ARRIVAL;
  };

  private toggleIsSearch = (): void => {
    if(this.searchQueryString) {
      this.isSearhProcess = true;
    } else {
      this.isSearhProcess = false;
    }
  };
}

export { AttendeesService };